// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-card {
  width: 100%;
}

app-recommendation-card {
  width: 100%;
}

app-quote-card {
  width: 100%;
}

ion-icon.progress-icon {
  margin-right: 10px;
}

.grid-header {
  font-weight: bold;
}

.count-number {
  font-size: 30px;
}

.count-number-label {
  font-size: 20px;
}

ion-accordion {
  margin-bottom: 10px;
  background-color: white;
}

ion-list.dash-list {
  background-color: var(--content-bg-color);
}
ion-list.dash-list ion-list-header.dark-blue-bg {
  --background: var(--dark-blue-bg);
  --color: white;
}
ion-list.dash-list ion-item.dash-item {
  margin: 10px auto;
}
ion-list.dash-list ng-container.dash-item {
  margin: 10px auto;
}

@media screen and (max-width: 370px) {
  h1 {
    font-size: 18px;
  }
  ion-title {
    font-size: 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/pages/dashboard/dashboard.page.scss","webpack://./../../../../../../Program%20Files%20(x86)/Jenkins/workspace/Quadra%20Service%20Call%20Pipeline/QuadraServiceCall/Client/src/app/pages/dashboard/dashboard.page.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;ACCJ;;ADEA;EACI,WAAA;ACCJ;;ADCA;EACI,WAAA;ACEJ;;ADCA;EACI,kBAAA;ACEJ;;ADCA;EACI,iBAAA;ACEJ;;ADCA;EACI,eAAA;ACEJ;;ADAA;EACI,eAAA;ACGJ;;ADAA;EACI,mBAAA;EACA,uBAAA;ACGJ;;ADAA;EACI,yCAAA;ACGJ;ADDI;EACI,iCAAA;EACA,cAAA;ACGR;ADAI;EACI,iBAAA;ACER;ADCI;EACI,iBAAA;ACCR;;ADGA;EACI;IACI,eAAA;ECAN;EDEE;IACI,eAAA;ECAN;AACF","sourcesContent":["ion-card {\r\n    width: 100%;\r\n}\r\n\r\napp-recommendation-card {\r\n    width: 100%;\r\n}\r\napp-quote-card {\r\n    width: 100%;\r\n}\r\n\r\nion-icon.progress-icon {\r\n    margin-right: 10px;\r\n}\r\n\r\n.grid-header {\r\n    font-weight: bold;\r\n}\r\n\r\n.count-number {\r\n    font-size: 30px;\r\n}\r\n.count-number-label {\r\n    font-size: 20px;\r\n}\r\n\r\nion-accordion {\r\n    margin-bottom: 10px;\r\n    background-color: white;\r\n}\r\n\r\nion-list.dash-list {\r\n    background-color: var(--content-bg-color);\r\n\r\n    ion-list-header.dark-blue-bg {\r\n        --background: var(--dark-blue-bg);\r\n        --color: white;\r\n    }\r\n\r\n    ion-item.dash-item {\r\n        margin: 10px auto;\r\n    }\r\n\r\n    ng-container.dash-item {\r\n        margin: 10px auto;\r\n    }\r\n}\r\n\r\n@media screen and (max-width: 370px) {\r\n    h1 {\r\n        font-size: 18px;\r\n    }\r\n    ion-title {\r\n        font-size: 20px;\r\n    }\r\n}\r\n","ion-card {\n  width: 100%;\n}\n\napp-recommendation-card {\n  width: 100%;\n}\n\napp-quote-card {\n  width: 100%;\n}\n\nion-icon.progress-icon {\n  margin-right: 10px;\n}\n\n.grid-header {\n  font-weight: bold;\n}\n\n.count-number {\n  font-size: 30px;\n}\n\n.count-number-label {\n  font-size: 20px;\n}\n\nion-accordion {\n  margin-bottom: 10px;\n  background-color: white;\n}\n\nion-list.dash-list {\n  background-color: var(--content-bg-color);\n}\nion-list.dash-list ion-list-header.dark-blue-bg {\n  --background: var(--dark-blue-bg);\n  --color: white;\n}\nion-list.dash-list ion-item.dash-item {\n  margin: 10px auto;\n}\nion-list.dash-list ng-container.dash-item {\n  margin: 10px auto;\n}\n\n@media screen and (max-width: 370px) {\n  h1 {\n    font-size: 18px;\n  }\n  ion-title {\n    font-size: 20px;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
